import { useState, useEffect, useRef } from 'react'
import { GET_CLINIC_LOCATION_LIST, SPECIALITY_LIST, SWITCHTOPROVIDERANDCLINIC } from '../../../repository/ClinicRepo'
import {
    ADD_PATIENT, ADD_PATIENT_FAMILY_MEMBER, GET_PATIENT_LIST, GET_PROVIDER_HYGIENIST_LIST, LINK_PATIENT_SOTA_CLOUD, MERGE_PATIENT_ACCOUNT, PATIENT_SUMMARY_History,
    PATIENT_SUMMARY_History_LIST, PATIENT_SUMMARY_AUDIO, PATIENT_SUMMARY_DELETE
} from '../../../repository/patientRepo'
import { COUNTRY_LIST, STATE_LIST, CITY_LIST, DELETE_UPLOAD_FILE } from '../../../repository/common'
import { toast } from "react-toastify"
import { Validation } from '../../common-components/validations'
import useReduxStore from '../../../hooks/useReduxStore'
import { handleTrimmedValue, removeFile, requiredMessage, requiredSelect } from '../../../Utils'
import moment from 'moment-timezone'
import { modalEnum, patientFormEnums, RegionOptions } from '../../../constant'
import { useDispatch } from 'react-redux'
import { patientDetails } from "../../../Slices/PatientSlice"
import useUploadImage from '../../../hooks/useUploadImage'
import { GET_PRIVACYMODE, UPDATE_PRIVACYMODE } from '../../../repository/schedulerRepo'
import { add } from "../../../Slices/AuthSlice";
import { useNavigate } from 'react-router-dom'
import { LOGOUT } from '../../../repository/auth'
import { familyMemberDetails } from '../../../Slices/familyMemberSlice'


const useHeader = () => {
    const { Dispatch, selector: user } = useReduxStore("auth")
    const { selector: PatientData } = useReduxStore("PatientData")

    const { selector: AgeData } = useReduxStore("AgeData")

    const mergeType = { duplicate: 'DUPLICATE', familyMember: 'FAMILYMEMBER' }
    const dispatch = useDispatch()
    const { UploadImage } = useUploadImage()
    const FileRef = useRef()
    const [licenseImage, setLicenseImage] = useState(null)
    const [allImage, setAllImage] = useState([])

    const [spinner, setSpinner] = useState(false)
    const [hippModeOnOff, setHippModeOnOff] = useState(false)
    const [createAppointmentModal, setCreateAppointmentModal] = useState({
        open: false,
        data: null,
        type: null,
        isBookWaiting: false
    })
    const [selectPatientModal, setSelectPatientModal] = useState(modalEnum)
    const [addPatientModal, setAddPatientModal] = useState(modalEnum)
    const [familyMemberModal, setFamilyMemberModal] = useState(modalEnum)
    const [mergeAccountModal, setMergeAccountModal] = useState(modalEnum)
    const [mergeConfirmModal, setMergeConfirmModal] = useState(modalEnum)
    const [patientListData, setPatientListData] = useState([])
    const [patientMergeList, setPatientMergeList] = useState([])
    const [patientSinkModal, setPatientSinkModal] = useState(modalEnum)

    const [countryListData, setCountryListData] = useState([])
    const [stateListData, setStateListData] = useState([])
    const [cityListData, setCityListData] = useState([])
    const [SpecialityListData, setSpecialityListData] = useState([])
    const [HygienistListData, setHygienistListData] = useState([])
    const [providerListData, setProviderListData] = useState([])
    const [patientFormInput, setPatientFormInput] = useState(patientFormEnums)
    const [punch, setPunch] = useState(true);
    const { title, firstName, middleName, lastName, salutation, preferredPronoun, gender, maritalStatus, dob, age, status, bloodGroup, isOrthoPatient, street, suiteAptNumber, region, country, state, city, zipcode, preferredContactMethod, phone, workPhone, email, emergencyContactPersonName, emergencyContactPersonPhoneNumber, relationshipWithPatient, paymentMode, referenceTo, referenceBy, responsibleParty, language, policyHolder, employmentType, preferredProvider, preferredHygienist,
    } = patientFormInput
    const [searchText, setSearchText] = useState("")
    const [action, setAction] = useState(false)
    const [actionPatient, setActionPatient] = useState(false)
    const [patientError, setPatientError] = useState({})
    const [selectedMergeOptions, setSelectedMergeOptions] = useState({ primary: null, secondary: null });
    const [totalCount, settotalCount] = useState(0)
    const [controller, setController] = useState({ page: 1, rowsPerPage: 10, searchPage: 1 });

    const [ClinicLocationListListData, setClinicLocationListData] = useState([])
    const [medicalHistoryModalOpen, setMedicalHistoryModalOpen] = useState(false);

    const [patientHistoryModalOpen, setPatientHistoryModalOpen] = useState(false);



    const navigate = useNavigate()

    const clearSelectedMerge = () => {
        setSelectedMergeOptions({ primary: null, secondary: null });
    }
    const clearForm = () => {
        setPatientFormInput(patientFormEnums)
        setPatientError({})
        setLicenseImage(null)
    }

    useEffect(() => {
        getPrivacyMode()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (addPatientModal?.open || familyMemberModal?.open) {
            getCountry()
            getSpecialityList()
            getProivderList()
            getProivderHygienistList()
        }
    }, [addPatientModal, familyMemberModal])
    useEffect(() => {
        if (selectPatientModal.open) {
            getPatientList()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [actionPatient, selectPatientModal, controller])

    useEffect(() => {
        getMergePatientList()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [action])

    useEffect(() => {
        if (patientHistoryModalOpen) {
            patientSummaryHistoryList()
        }
    }, [patientHistoryModalOpen])

    const getPatientFamilyList = async () => {
        try {
            let payload = {
                count: 10000,
                page: 1,
                clinicId: user?.clinic_id,
                // isDeleted: false,
                id: PatientData?.id,
                listMember: true
            }
            setSpinner(true)
            let response = await GET_PATIENT_LIST(payload)
            Dispatch(familyMemberDetails(response?.data))
        } catch (error) {
            toast.error(error?.message)
        }
        setSpinner(false)
    }

    // GET_PRIVACY_MODE
    let getPrivacyMode = async () => {
        try {
            setSpinner(true)
            let response = await GET_PRIVACYMODE()
            setHippModeOnOff(response?.data?.privacyMode)
            let hippamode = { ...PatientData, hippModeOnOff: response?.data?.privacyMode }
            dispatch(patientDetails(hippamode))
        } catch (error) {
            toast.error(error?.message)
        }
        setSpinner(false)
    }
    let updatePrivacyMode = async (mode) => {
        try {
            setSpinner(true)
            let response = await UPDATE_PRIVACYMODE({ privacyMode: mode })
            toast.success(response?.message)
            getPrivacyMode()
        } catch (error) {
            toast.error(error?.message)
        }
        setSpinner(false)
    }

    // GET_PATIENT_LIST
    const getPatientList = async (countryId) => {
        try {
            let payload = {
                count: controller?.rowsPerPage,
                page: controller?.page,
                clinicId: user?.clinic_id
                // isDeleted: false,
            }
            if (searchText) {
                payload.searchName = searchText
            }
            setSpinner(true)
            let response = await GET_PATIENT_LIST(payload)
            settotalCount(response?.count)
            setPatientListData(response?.data?.map((cur) => {
                return { ...cur, fullName: `${cur?.firstName || ""} ${cur?.lastName || ""}` }
            }))

        } catch (error) {
            toast.error(error?.message)
        }
        setSpinner(false)
    }

    // GET Merge _PATIENT_LIST
    const getMergePatientList = async (countryId) => {
        try {
            let payload = {
                count: 10000,
                page: 1,
                clinicId: user?.clinic_id,
                listOnlyPrimary: true,
                // isDeleted: false,
            }
            if (searchText) {
                payload.searchName = searchText
            }
            setSpinner(true)
            let response = await GET_PATIENT_LIST(payload)
            setPatientMergeList(response?.data)

        } catch (error) {
            toast.error(error?.message)
        }
        setSpinner(false)
    }

    // Handle Same As Primary Patient
    const handleSameAsPrimaryPatient = async (event) => {
        if (event.target.checked) {
            if (PatientData?.country) {
                await getCountry(PatientData?.country)
            }
            if (PatientData?.state) {
                await getState(PatientData?.country, PatientData?.state)
            } if (PatientData?.city) {
                await getCity(PatientData?.country, PatientData?.state, PatientData?.city)
            }
            let newRegion = RegionOptions?.filter((item) => item?.value === PatientData?.region)
            setPatientFormInput(prev => ({
                ...prev,
                street: PatientData?.street,
                suiteAptNumber: PatientData?.suiteAptNumber,
                region: newRegion,
                // country: PatientData?.country,
                // state: "",
                // city: "",
                zipcode: PatientData?.zipcode,
            }));
        } else {
            setPatientFormInput(prev => ({
                ...prev,
                street: "",
                suiteAptNumber: "",
                region: "",
                country: "",
                state: "",
                city: "",
                zipcode: "",
            }));
        }
    }


    const getCountry = async (countryId) => {
        try {
            let payload = {
                count: 10000,
                isDeleted: false,
            }
            setSpinner(true)
            let response = await COUNTRY_LIST(payload)
            setCountryListData(response.data)
            if (countryId) {
                let newCountry = response?.data?.filter(item => item.id === countryId)
                setPatientFormInput((prev) => ({ ...prev, country: newCountry }))
            }
        } catch (error) {

        }
        setSpinner(false)
    }

    const logout = async () => {
        try {
            let payload = {
                token: user?.token
            }
            setSpinner(true)
            await LOGOUT(payload)
            Dispatch(add({}))
            Dispatch(patientDetails({}))
            navigate("/")
        } catch (error) {

        }
        setSpinner(false)
    }

    // Get State List
    const getState = async (countryId, stateID) => {
        try {
            let payload = {
                count: 10000,
                isDeleted: false,
                countryId: countryId
            }
            setSpinner(true)
            let response = await STATE_LIST(payload)
            if (stateID) {
                let newState = response?.data?.filter(item => item.id === stateID)
                setPatientFormInput((prev) => ({ ...prev, state: newState }))
            }
            setStateListData(response.data)
        } catch (error) {

        }
        setSpinner(false)
    }
    // Get City List
    const getCity = async (countryId, stateID, addressCity1) => {
        try {
            let payload = {
                count: 10000,
                countryId: countryId,
                isDeleted: false,
                stateId: stateID
            }
            setSpinner(true)
            let response = await CITY_LIST(payload)
            setCityListData(response.data)
            if (addressCity1) {
                let newCity = response?.data?.filter(item => item.id === addressCity1)
                setPatientFormInput((prev) => ({ ...prev, city: newCity }))
            }
        } catch (error) {

        }
        setSpinner(false)
    }
    // providerList
    let getProivderList = async (providerId) => {
        try {
            let payload = {
                count: 10000,
                isDeleted: false,
            }
            setSpinner(true)
            let response = await GET_PROVIDER_HYGIENIST_LIST(payload)
            setProviderListData(response.data)
            if (providerId) {
                let newProvider = response?.data?.filter(item => item.providerId === providerId)
                setPatientFormInput((prev) => ({ ...prev, preferredProvider: newProvider }))
            }
        } catch (error) {

        }
        setSpinner(false)
    }
    // get Proivder Hygienist List
    let getProivderHygienistList = async (hygienistId) => {
        try {
            let payload = {
                count: 10000,
                isDeleted: false,
                roleName: "HYGIENIST",
            }
            setSpinner(true)
            let response = await GET_PROVIDER_HYGIENIST_LIST(payload)
            setHygienistListData(response.data)
            if (hygienistId) {
                let newHygienist = response?.data?.filter(item => item.providerId === hygienistId)
                setPatientFormInput((prev) => ({ ...prev, preferredHygienist: newHygienist }))
            }
        } catch (error) {

        }
        setSpinner(false)
    }
    // Speciality List
    const getSpecialityList = async () => {
        setSpinner(true)
        try {
            let payload = {
            }
            let response = await SPECIALITY_LIST(payload)
            setSpecialityListData(response.data)
        } catch (error) {
            toast.error(error.message)
            setSpecialityListData([])
        }
        setSpinner(false)

    }

    // handle merge acount radio input's
    const handleMergeRadioChange = (patData) => {
        setSelectedMergeOptions((prev) => {
            if (prev.primary === null) {
                return { ...prev, primary: patData?.id, primaryData: patData };
            } else if (prev.secondary === null) {
                return { ...prev, secondary: patData?.id, secondaryData: patData };
            } else {
                return prev; // Do not update if both primary and secondary are already selected
            }
        });
    };

    // patientDetails
    const selectedPatient = (row) => {
        let newData = { ...PatientData, ...row }
        dispatch(patientDetails(newData))
        setSelectPatientModal({ data: null, open: false })
    }
    // Calculate age
    const handalDOB = (value) => {
        let today = new Date();
        let birthDate = new Date(value);
        let age = today.getFullYear() - birthDate.getFullYear();
        let m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        setPatientFormInput((prevProps) => ({ ...prevProps, age: age }));
        setPatientError((pre) => {
            delete pre["age"];
            return { ...pre };
        });
    }
    // handle Clinic Location Input
    const handleInputChange = (event) => {
        const { name, value, type, checked } = event.target;
        const newValue = type === 'checkbox' ? checked : value;
        const finalValue = handleTrimmedValue(newValue);
        setPatientFormInput((prevProps) => ({
            ...prevProps,
            [name]: finalValue
        }));
        if (name == "bypassEmail" && checked) {
            setPatientFormInput((prev) => ({ ...prev, email: "" }))
        } else if (name == "email") {
            setPatientFormInput((prev) => ({ ...prev, bypassEmail: false }))
        }
        if (name === "dob") {
            handalDOB(value);
        }
        setPatientError((prev) => {
            const { [name]: removed, ...rest } = prev;
            return rest;
        });
    };

    // Error Message
    const errorMessage = {
        firstName: requiredMessage('first name'),
        lastName: requiredMessage('last name'),
        preferredPronoun: requiredSelect('preferred pronoun'),
        dob: requiredMessage('dob'),
        age: requiredMessage('age'),
        status: requiredSelect('status'),
        preferredContactMethod: requiredMessage('preferred contact method'),
        phone: requiredMessage('Phone number'),
        email: requiredMessage('email'),
    }
    // Clinic Error hendling
    const isValid = () => {
        const errorObj = {}
        if (!firstName) {
            errorObj['firstName'] = errorMessage['firstName']
        }
        if (!lastName) {
            errorObj['lastName'] = errorMessage['lastName']
        }
        // if (!preferredPronoun?.length) {
        //     errorObj['preferredPronoun'] = errorMessage['preferredPronoun']
        // }
        if (!dob) {
            errorObj['dob'] = errorMessage['dob']
        }
        if (!age) {
            errorObj['age'] = errorMessage['age']
        }
        if (!status?.length) {
            errorObj['status'] = errorMessage['status']
        }
        // if (!preferredContactMethod) {
        //     errorObj['preferredContactMethod'] = errorMessage['preferredContactMethod']
        // }
        // if (!phone) {
        //     errorObj['phone'] = errorMessage['phone']
        // }
        // if (!patientFormInput?.bypassEmail) {
        //     if (!email) {
        //         errorObj['email'] = errorMessage['email']
        //     } else if (!patientFormInput?.email?.match(Validation.pattern.EMAIL)) {
        //         errorObj["email"] = "Please enter valid email";
        //     }
        // }
        setPatientError(errorObj)
        return !Object.keys(errorObj)?.length
    }

    // Add Patient form||ADD_PATIENT_FAMILY_MEMBER
    const handleAddSubmit = async (event, type) => {
        event.preventDefault()
        if (!isValid()) return
        setSpinner(true)
        const formattedDob = moment(dob).format("YYYY-MM-DD");
        try {
            let payload = {
                clinicId: user?.clinic_id,
                createdById: "",
                notes: patientFormInput?.note,
                bypassEmail: patientFormInput?.bypassEmail,
                title: title,
                firstName: firstName,
                lastName: lastName,
                middleName: middleName,
                salutation: salutation,
                preferredPronoun: preferredPronoun?.[0]?.value,
                gender: gender?.[0]?.value,
                maritalStatus: maritalStatus?.[0]?.value,
                dob: formattedDob,
                age: age,
                status: status?.[0]?.value,
                bloodGroup: bloodGroup?.[0]?.value,
                isOrthoPatient: isOrthoPatient?.[0]?.value,
                street: street,
                suiteAptNumber: suiteAptNumber,
                region: region[0]?.value,
                country: country[0]?.id,
                state: state[0]?.id,
                city: city[0]?.id,
                zipCode: zipcode,
                preferredContactMethod: preferredContactMethod,
                phone: phone,
                workPhone: workPhone,
                email: patientFormInput?.bypassEmail ? null : email || null,
                emergencyContactPersonName: emergencyContactPersonName,
                emergencyContactPersonPhoneNumber: emergencyContactPersonPhoneNumber,
                relationshipWithPatient: relationshipWithPatient[0]?.value,
                driversLicense: licenseImage,
                responsibleParty: responsibleParty,
                language: language,
                policyHolder: policyHolder,
                employmentType: employmentType,
                preferredProvider: preferredProvider[0]?.providerId,
                preferredHygienist: preferredHygienist[0]?.providerId,
                paymentMode: paymentMode[0]?.value,
                // billingType: billingType[0]?.value,
                billingType: null,

                referredTo: referenceTo,
                referredBy: referenceBy,
            }


            if (type === "FAMILY") {
                payload.parentId = PatientData?.id
                let response = await ADD_PATIENT_FAMILY_MEMBER(payload)
                setFamilyMemberModal({ open: false, data: null })
                // clearForm()
                getPatientFamilyList()
                toast.success(response.message)
            } else {
                let response = await ADD_PATIENT(payload)
                getPatientList()
                setAddPatientModal({ data: null, open: false })
                toast.success(response.message)
            }
        } catch (err) {
            toast.error(err.message)
        }
        setSpinner(false)
    }
    // const punchInOut = async (type) => {
    //     try {
    //         setSpinner(true)
    //         const payLoad = {
    //             userId: user?.user_id,
    //             clinicId: user?.clinic_id,
    //             type: type,
    //             locationId: 7
    //         }
    //         const response = await PUNCHINOUT(payLoad)
    //         toast.success(response?.message)
    //         // setPunch(!punch);
    //         punchStatus()

    //     }
    //     catch {

    //     }
    //     setSpinner(false)
    // }
    // const punchStatus = async () => {
    //     try {
    //         const payLoad = {
    //             userId: user?.user_id,
    //             clinicId: user?.clinic_id,
    //             locationId: 7
    //         }
    //         const response = await CURRENT_STATUS(payLoad)
    //         setPunch(response.data.show === "PUNCHIN" ? true : false)
    //     }
    //     catch {

    //     }
    // }


    //MERGE_PATIENT_ACCOUNT
    const mergePatinetHandler = async () => {
        try {
            let payload = {
                mergeType: mergeAccountModal?.type === mergeType?.duplicate ? "MERGE_DUPLICATE" : "MERGE_FAMILY_MEMBER",
                mergeIntoId: selectedMergeOptions?.primary,
                patientToMergeId: selectedMergeOptions?.secondary,
            }
            setSpinner(true)
            let response = await MERGE_PATIENT_ACCOUNT(payload)
            setMergeConfirmModal({ open: false, data: null })
            setMergeAccountModal({ open: false, data: null })

            clearSelectedMerge()
            toast.success(response.message)
        } catch (error) {
            toast.error(error.message)
        }
        setSpinner(false)
    }

    const applayFilter = (type) => {
        if (type === "Merge") {
            getMergePatientList()
        } else {
            getPatientList()
        }
    }
    const reset = (type) => {
        if (type === "Merge") {
            setAction(!action)
        } else {
            setActionPatient(!actionPatient)
        }
        setSearchText('')
    }


    // GET_CLINIC_LOCATION_LIST
    const getClinicLocationList = async () => {
        setSpinner(true)
        try {
            let payload = {}
            // if (filter?.searchText) {
            //     payload.searchName = filter.searchText
            // }

            let response = await GET_CLINIC_LOCATION_LIST(payload)
            setClinicLocationListData(response?.data)
        } catch (error) {

        }
        setSpinner(false)
    }

    useEffect(() => {
        getClinicLocationList()
    }, [])

    const sinkPatient = async () => {
        setSpinner(true)
        try {
            let payload = { clinicId: user?.clinic_id }
            let response = await LINK_PATIENT_SOTA_CLOUD(payload)
            toast.success(response?.message)
            setPatientSinkModal({ data: {}, open: false })
        } catch (error) {
            toast.error(error.message)
            setSpecialityListData([])
        }
        setSpinner(false)

    }

    // switch to provider and clinic
    const switchToProviderAndClinic = async () => {
        try {
            setSpinner(true)
            let responese = await SWITCHTOPROVIDERANDCLINIC()
            Dispatch(add(responese.data))
            Dispatch(patientDetails({}))
            // await getDetails()
        } catch (error) {
        }
        setSpinner(false)
    }



    const [patientSummary, setPatientSummary] = useState([]);
    const [isRecording, setIsRecording] = useState(false);
    const [recordingTime, setRecordingTime] = useState(0);
    const [audioUrl, setAudioUrl] = useState(null);
    const mediaRecorderRef = useRef(null);
    const audioChunksRef = useRef([]);
    const timerRef = useRef(null);
    const [audioBlob, setAudioBlob] = useState(null);
    const [isMuted, setIsMuted] = useState(false);
    const currentAudioRef = useRef(null);
    const [hasAudio, setHasAudio] = useState(false);
    // Convert seconds to MM:SS format
    const formatTime = (seconds) => {
        const min = String(Math.floor(seconds / 60)).padStart(2, '0');
        const sec = String(seconds % 60).padStart(2, '0');
        return `${min}:${sec}`;
    };

    const [question, setQuestion] = useState("");
    const [activeCursor, setActiveCursor] = useState(null);
    const [activeRequestMeta, setActiveRequestMeta] = useState(null);
    const handleChange = (e) => {
        setQuestion(e.target.value);
    };

    const patientSummaryHistory = async () => {
        if (!question.trim()) return;

        const tempMessage = {
            question: question,
            summary: 'AI is typing...',
            isLoading: true
        };

        setPatientSummary(prev => [...prev, tempMessage]);
        setQuestion('');
        setSpinner(true);

        try {
            const payload = {
                patientId: PatientData?.id,
                clinicId: user?.clinic_id,
                age: AgeData?.selectedAge || null,
                question: question
            };

            const response = await PATIENT_SUMMARY_History(payload);
            if (response?.data) {
                // response.data should now include:
                // summary, hasMore, nextCursor, previewId (optional), audioFile
                const newItem = {
                    question: payload.question,
                    summary: response.data.summary || response.data.text || "",
                    isLoading: false,
                    hasMore: !!response.data.hasMore,
                    nextCursor: response.data.nextCursor || null,
                    previewId: response.data.previewId || null,
                };

                // replace last temp message with real response
                setPatientSummary(prev => {
                    const updated = [...prev];
                    updated[updated.length - 1] = newItem;
                    return updated;
                });

                // store cursor info for "Show more"
                setActiveCursor(response.data.nextCursor || null);
                setActiveRequestMeta(payload);

                // play audio (keep your existing logic)
                const audioItem = response.data?.audioFile;
                if (audioItem) {
                    setHasAudio(true); //  AI audio is available

                    if (currentAudioRef.current) {
                        currentAudioRef.current.pause();
                        currentAudioRef.current = null;
                    }

                    const audio = new Audio(audioItem);
                    audio.muted = isMuted;
                    audio.play().catch((err) => console.warn("Auto-play failed:", err.message));

                    currentAudioRef.current = audio;
                } else {
                    setHasAudio(false); // no audio returned
                }
            }


        } catch (error) {
            const errorMsg = error?.response?.data?.message || error.message || 'An error occurred';
            toast.error(errorMsg);
            setPatientSummary(prev => {
                const updated = [...prev];
                updated[updated.length - 1] = {
                    ...updated[updated.length - 1],
                    summary: "",
                    question: "",
                    isLoading: false
                };
                return updated;
            });
        } finally {
            setSpinner(false);
        }
    };

    const showMoreSummary = async (messageIndex) => {
        const msg = patientSummary[messageIndex];
        if (!msg?.nextCursor || !activeRequestMeta) return;

        try {
            setSpinner(true);

            // loader on button
            setPatientSummary(prev => {
                const updated = [...prev];
                updated[messageIndex] = { ...updated[messageIndex], isLoading: true };
                return updated;
            });

            const payload = {
                ...activeRequestMeta,
                cursor: msg.nextCursor,
                previewId: msg.previewId,
                question: msg.question   //  SAME QUESTION
            };

            const response = await PATIENT_SUMMARY_History(payload);

            if (response?.data) {
                setPatientSummary(prev => {
                    const updated = [...prev];

                    // stop loader on old message
                    updated[messageIndex] = {
                        ...updated[messageIndex],
                        isLoading: false,
                        hasMore: false   // old message ka show more band
                    };

                    //  PUSH NEW MESSAGE (THIS IS THE FIX)
                    updated.push({
                        question: msg.question,                 // ✅ QUESTION PRINT
                        summary: response.data.summary || "",
                        hasMore: !!response.data.hasMore,
                        nextCursor: response.data.nextCursor || null,
                        isLoading: false,
                        previewId: msg.previewId
                    });

                    return updated;
                });
            }
        } catch (error) {
            toast.error(error?.message || "Failed to load more");
        } finally {
            setSpinner(false);
        }
    };


    const patientSummaryHistoryList = async () => {
        setSpinner(true)
        try {
            let payload = {
                patientId: PatientData?.id,
                clinicId: user?.clinic_id,
            }
            let response = await PATIENT_SUMMARY_History_LIST(payload)
            if (response) {
                setPatientSummary(response.data)
            }
        } catch (error) {
            toast.error(error.message)
            setPatientSummary([])
        }
        finally {
            setSpinner(false)
        }

    }

    const handleStartRecording = async () => {
        try {
            if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
                toast.error("Microphone access is not supported by this browser.");
                return;
            }
            const devices = await navigator.mediaDevices.enumerateDevices();
            const audioInput = devices.find((device) => device.kind === "audioinput");

            if (!audioInput) {
                toast.error("No microphone device found. Please connect a microphone.");
                return;
            }

            //  Request audio stream
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

            mediaRecorderRef.current = new MediaRecorder(stream);
            audioChunksRef.current = [];

            mediaRecorderRef.current.ondataavailable = (e) => {
                if (e.data.size > 0) {
                    audioChunksRef.current.push(e.data);
                }
            };

            mediaRecorderRef.current.onstop = async () => {
                const blob = new Blob(audioChunksRef.current, { type: "audio/webm" });
                setAudioBlob(blob);
                const url = URL.createObjectURL(blob);
                setAudioUrl(url);

                // 👇 1. Push temporary message like in patientSummaryHistory
                const tempMessage = {
                    summary: 'AI is typing...',
                    isLoading: true
                };
                setPatientSummary(prev => [...prev, tempMessage]);
                try {
                    const formData = new FormData();
                    formData.append("patientId", PatientData?.id);
                    formData.append("clinicId", user?.clinic_id);
                    formData.append("age", AgeData?.selectedAge || "");
                    formData.append("audio", blob, "recording.webm");

                    setSpinner(true);
                    const response = await PATIENT_SUMMARY_AUDIO(formData);
                    setSpinner(false);

                    // if (response.status === 200) {
                    //     patientSummaryHistoryList();
                    //     setAudioUrl(null);
                    //     setAudioBlob(null);
                    // }

                    if (response?.data) {
                        const newItem = {
                            question: response.data.question || "Voice Input",
                            summary: response.data.summary || "",
                            isLoading: false,
                            hasMore: !!response.data.hasMore,
                            nextCursor: response.data.nextCursor || null,
                            previewId: response.data.previewId || null,
                            isAudio: true   //  ADD THIS
                        };
                        //  replace temp message
                        setPatientSummary(prev => {
                            const updated = [...prev];
                            updated[updated.length - 1] = newItem;
                            return updated;
                        });

                        // cursor meta for show more
                        setActiveCursor(response.data.nextCursor || null);
                        setActiveRequestMeta({
                            patientId: PatientData?.id,
                            clinicId: user?.clinic_id,
                            age: AgeData?.selectedAge || null
                        });
                    }
                    else {
                        toast.error("Upload failed");
                        // 👇 Optional: Replace temp message with failure text
                        setPatientSummary(prev => {
                            const updated = [...prev];
                            updated[updated.length - 1] = {
                                ...updated[updated.length - 1],
                                summary: "",
                                question: "",
                                isLoading: false
                            };
                            return updated;
                        });
                    }
                } catch (error) {
                    setSpinner(false);
                    toast.error(error.message || "Upload error");
                    //  Optional: Replace temp message with error message
                    setPatientSummary(prev => {
                        const updated = [...prev];
                        updated[updated.length - 1] = {
                            ...updated[updated.length - 1],
                            summary: "",
                            question: "",
                            isLoading: false
                        };
                        return updated;
                    });
                }
            };

            mediaRecorderRef.current.start();
            setIsRecording(true);
            setRecordingTime(0);

            timerRef.current = setInterval(() => {
                setRecordingTime((prev) => prev + 1);
            }, 1000);
        } catch (error) {
            console.error("Error accessing microphone:", error);

            if (error.name === "NotFoundError") {
                toast.error("No input device found. Please connect a microphone and try again.");
            } else if (error.name === "NotAllowedError") {
                toast.error("Microphone access denied. Please allow microphone permissions.");
            } else {
                toast.error("Unable to access microphone. Please check your settings.");
            }
        }
    };


    const SeemorehandleStartRecording = async (messageIndex) => {
        const msg = patientSummary[messageIndex];
        if (!msg?.nextCursor || !activeRequestMeta || !audioBlob) return;

        try {
            setSpinner(true);

            // 🔹 show loader on existing message
            setPatientSummary(prev => {
                const updated = [...prev];
                updated[messageIndex] = {
                    ...updated[messageIndex],
                    isLoading: true
                };
                return updated;
            });

            //  FormData with audio
            const formData = new FormData();
            formData.append("patientId", activeRequestMeta.patientId);
            formData.append("clinicId", activeRequestMeta.clinicId);
            formData.append("age", activeRequestMeta.age || "");
            formData.append("cursor", msg.nextCursor);
            formData.append("previewId", msg.previewId);
            formData.append("audio", audioBlob, "recording.webm");

            const response = await PATIENT_SUMMARY_AUDIO(formData);
            if (response?.data) {
                setPatientSummary(prev => {
                    const updated = [...prev];

                    // stop loader & disable show more on old message
                    updated[messageIndex] = {
                        ...updated[messageIndex],
                        isLoading: false,
                        hasMore: false
                    };

                    // push new audio summary
                    updated.push({
                        question: msg.question || "Voice Input",
                        summary: response.data.summary || "",
                        hasMore: !!response.data.hasMore,
                        nextCursor: response.data.nextCursor || null,
                        isLoading: false,
                        previewId: msg.previewId,
                        isAudio: true   //  ADD THIS
                    });
                    return updated;
                });
            }
        } catch (error) {
            toast.error(error?.message || "Failed to load more audio summary");
        } finally {
            setSpinner(false);
        }
    };



    const handleStopRecording = () => {
        if (
            mediaRecorderRef.current &&
            mediaRecorderRef.current.state !== 'inactive'
        ) {
            mediaRecorderRef.current.stop();

            // Stop audio stream tracks to release mic (remove Edge mic icon)
            const stream = mediaRecorderRef.current.stream;
            stream.getTracks().forEach((track) => track.stop());

            clearInterval(timerRef.current);
            setIsRecording(false);
        }
    };




    // const deletePatientHistory = async () => {
    //     try {
    //         let payload = {
    //             summaryData: [],
    //             patientId: PatientData?.id,
    //             clinicId: user?.clinic_id,
    //         }
    //         console.log(payload, "111111111111");

    //         // setSpinner(true)
    //         // let responce = await PATIENT_SUMMARY_DELETE(payload)
    //         // toast.success(responce?.message)
    //         // patientSummaryHistoryList()
    //     } catch (error) {
    //         toast.error(error?.message)
    //     } finally {
    //         setSpinner(false)
    //     }
    // }

    return {
        data: {
            spinner,
            addPatientModal,
            familyMemberModal,
            selectPatientModal,
            createAppointmentModal,
            hippModeOnOff,
            //Patient data--------------//
            patientFormInput,
            countryListData,
            stateListData,
            cityListData,
            patientError,
            SpecialityListData,
            patientListData,
            providerListData,
            HygienistListData,
            licenseImage,
            FileRef,
            allImage,
            // selectedMergeOptions----------------//
            selectedMergeOptions,
            mergeAccountModal,
            mergeConfirmModal,
            patientMergeList,
            mergeType,
            searchText,
            punch,
            totalCount,
            controller,
            ClinicLocationListListData,
            patientSinkModal,
            medicalHistoryModalOpen,
            patientHistoryModalOpen,
            patientSummary,
            question,
            isRecording,
            recordingTime,
            audioUrl,
            isMuted,
            currentAudioRef,
            hasAudio,

        },
        methods: {
            setSpinner,
            setAddPatientModal,
            setFamilyMemberModal,
            setSelectPatientModal,
            reset,
            applayFilter,
            setSearchText,
            setCreateAppointmentModal,
            setHippModeOnOff,
            updatePrivacyMode,
            UploadImage,
            setLicenseImage,
            //patient methods------------//
            getState,
            getCity,
            clearForm,
            handleInputChange,
            handleAddSubmit,
            selectedPatient,
            handleSameAsPrimaryPatient,
            removeFile,
            setAllImage,
            // patient merge -----------//
            setMergeAccountModal,
            setMergeConfirmModal,
            setSelectedMergeOptions,
            handleMergeRadioChange,
            mergePatinetHandler,
            getMergePatientList,
            clearSelectedMerge,
            // punchInOut,
            setPunch,
            setController,
            // punchInOut,
            // clinic location  switch---------//
            getClinicLocationList,
            logout,
            setPatientSinkModal,
            sinkPatient,
            switchToProviderAndClinic,
            setMedicalHistoryModalOpen,
            setPatientHistoryModalOpen,
            patientSummaryHistory,
            setPatientSummary,
            handleChange,
            handleStartRecording,
            handleStopRecording,
            formatTime,
            setIsMuted,
            showMoreSummary,
            SeemorehandleStartRecording
            // deletePatientHistory,

        }
    }
}

export default useHeader